import React from "react";
import MUIThemeProvider from "@mui/material/styles/ThemeProvider";

import defaultTheme from "./defaultTheme";

const ThemeProvider = ({ children }) => (
  <MUIThemeProvider theme={defaultTheme}>{children}</MUIThemeProvider>
);

export default ThemeProvider;
